import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-helpers';
import { LinkButton } from '@adsk/alloy-react-button';
import { addCompanyStyle, noCompanyTextStyle } from './helpers/styles';

const getFilteredResultsLength = (options, input) => {
  return options.filter(
    (option) => option.name.trim().toLowerCase() === input.trim().toLowerCase()
  ).length;
};

const addCompanyFooterRenderer = ({
  onCreateCompany = () => {},
  companyCreationValidator = () => true,
} = {}) => {
  const CompanyFieldFooter = (props = {}) => {
    const { options, stateAndHelpers } = props;
    const { inputValue } = stateAndHelpers;
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

    if (
      inputValue.length < 3 ||
      getFilteredResultsLength(options, inputValue) > 0 ||
      !companyCreationValidator()
    ) {
      return null;
    }

    return (
      <div css={addCompanyStyle}>
        <div css={noCompanyTextStyle}>{T.translate('NO_COMPANY_MESSAGE')}</div>
        <LinkButton onClick={() => onCreateCompany(stateAndHelpers)}>
          {`+ ${T.translate('ADD_COMPANY_MESSAGE')}
          ${inputValue}`}
        </LinkButton>
      </div>
    );
  };

  CompanyFieldFooter.propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
    stateAndHelpers: PropTypes.shape({
      inputValue: PropTypes.string.isRequired,
    }).isRequired,
  };

  return CompanyFieldFooter;
};

export default addCompanyFooterRenderer;
